.assessmentHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.categorySelect {
    max-width: 200px;
    flex: 1;
}
